import axiosInstance from "../../../../../shared/api/axiosInstance.js";
import { baseUrl, PASSWORD_USER, EDIT_USER_ACTIVE, DELETE_USER } from "../../../../../shared/api/endpoints.js";
/** Keeps the existing PUT request and response contract. */
export function passwordUser(data, token) {
  return axiosInstance.put(`${baseUrl}/${PASSWORD_USER}`, data, {
    headers: {
      Authorization: `Bearer ${token}`,
      "Content-Type": "multipart/form-data"
    }
  });
}

/** Keeps the existing PUT request and response contract. */
export function editUserActive(userData, token) {
  return axiosInstance.put(`${baseUrl}/${EDIT_USER_ACTIVE}`, {
    ...userData,
    active: !userData.active
  }, {
    headers: {
      Authorization: `Bearer ${token}`,
      "Content-Type": "multipart/form-data"
    }
  });
}

/** Keeps the existing DELETE request and response contract. */
export function deleteUser(userData, token) {
  return axiosInstance.delete(`${baseUrl}/${DELETE_USER}?id=${userData?.id}`, {
    headers: {
      Authorization: `Bearer ${token}`,
      "Content-Type": "multipart/form-data"
    }
  });
}
